import { BaseScheduleDetail } from '../../@paco/entities/BaseSchedule/BaseSchedule'

import { getUserFullName } from '../../helpers'
import UpToAndIncludingDate from '../../helpers/date/UpToAndIncludingDate'
import { ShiftPlanningType, ShiftPlanningViewModel, ShiftType } from '../../models'
import { transformToBaseScheduleShift } from '../BaseScheduleShift/BaseScheduleShiftTransformers'
import { transformDepartmentResource } from '../Departments/DepartmentsTransformers'
import {
    BaseScheduleFormData,
    BaseScheduleIndexViewModel,
    BaseScheduleRequest,
    BaseScheduleResource,
    BaseScheduleViewModel,
    PublishBaseScheduleResultResource,
    PublishBaseScheduleResultViewModel,
} from './BaseSchedule'

export const transformToBaseScheduleIndex = (baseScheduleResource: BaseScheduleResource, lazyLoaded = false): BaseScheduleIndexViewModel => ({
    id: baseScheduleResource.id,
    name: baseScheduleResource.name,
    createdBy: getUserFullName(baseScheduleResource.owner),
    shifts: (baseScheduleResource.baseScheduleShifts || [])
        .map((shift) => transformToBaseScheduleShift(shift)),
    departments: (lazyLoaded && baseScheduleResource.baseScheduleShifts)
        ? baseScheduleResource.baseScheduleShifts.map(({ department }) => (transformDepartmentResource(department)))
        : [],
})

export const transformToBaseSchedule = (baseScheduleResource: BaseScheduleResource): BaseScheduleViewModel => ({
    id: baseScheduleResource.id,
    name: baseScheduleResource.name,
    totalWeeks: 1,
    shifts: baseScheduleResource.baseScheduleShifts?.map(transformToBaseScheduleShift) || [],
})

export const transformToBaseScheduleFormDataToRequest = (baseScheduleFormData: BaseScheduleFormData): BaseScheduleRequest => ({
    type: 'baseSchedules',
    id: baseScheduleFormData?.id,
    attributes: {
        name: baseScheduleFormData.name,
    },
})

export const transformToPublishBaseScheduleResult = (publishBaseScheduleResult: PublishBaseScheduleResultResource): PublishBaseScheduleResultViewModel => ({
    id: publishBaseScheduleResult.id,
    type: 'publishBaseScheduleResult',
    attributes: {
        baseScheduleStatuses: publishBaseScheduleResult.baseScheduleStatuses,
        publishedCount: publishBaseScheduleResult.publishedCount,
    },
})

export const transformBaseScheduleDetailToViewModel = (detail: BaseScheduleDetail): BaseScheduleViewModel => ({
    id: detail.id,
    name: detail.name,
    totalWeeks: detail.totalWeeks,
    shifts: detail.shifts.map(shift => ({
        type: ShiftType.baseSchedule,
        id: shift.id,
        peopleLimit: shift.peopleLimit,
        dayNumber: shift.dayNumber,
        weekNumber: shift.weekNumber,
        start: shift.period.start,
        end: new UpToAndIncludingDate(shift.period.end),
        department: shift.department ? {
            type: 'departments',
            id: shift.department.id,
            name: shift.department.name,
        } : undefined,
        shiftPlannings: shift.shiftPlannings.map(planning => ({
            ...planning,
            id: planning.id || '',
            type: ShiftPlanningType.baseSchedule,
            start: planning.period.start,
            end: new UpToAndIncludingDate(planning.period.end),
            comments: [],
            user: {
                ...planning.user,
                person: {
                    isCompanyMedic: planning.user.companyMedic,
                },
            },
        } as unknown as ShiftPlanningViewModel)),
        baseScheduleId: detail.id,
    })),
    comments: (Array.isArray(detail.dayComments) ? detail.dayComments : [detail.dayComments])
        .filter(comment => !! comment && !! comment.id)
        .map(comment => ({
            id: comment.id,
            body: comment.body,
            type: 'baseScheduleDayComment',
            createdAt: new Date(),
            dayNumber: comment.dayNumber,
            owner: comment.owner,
        })),
})
